import {FeaturesEnum} from './featuresFlagEnum';
import {ProductEnum} from './productEnum';

export const MY_HOSPITALIZATION_FEATURE_BY_HOST = {
	[ProductEnum.HAP]: FeaturesEnum.PORTAL_FEATURE_INTERNACAO_HAP,
	[ProductEnum.CCG]: FeaturesEnum.PORTAL_FEATURE_INTERNACAO_CCG,
	[ProductEnum.CLINIPAM]: FeaturesEnum.PORTAL_FEATURE_INTERNACAO_CLINIPAM,
	[ProductEnum.GNDI_MINAS]: FeaturesEnum.PORTAL_FEATURE_INTERNACAO_NDIMINAS,
	[ProductEnum.GNDI]: FeaturesEnum.PORTAL_FEATURE_INTERNACAO_NDISP,
	[ProductEnum.NOTREDAME_SAUDE]: FeaturesEnum.PORTAL_FEATURE_INTERNACAO_NDISP,
};
